import { SearchableSelect } from "@risalabs_frontend_org/oasis-ui-kit";
import InputPanel from "./components/InputPanel";
import ResultsPanel from "./components/ResultsPanel";
import { PLAYGROUND_ORG_OPTIONS } from "./playGroundConstants";
import usePlayGround from "./usePlayGround";

const PlayGround = () => {
  const {
    selectedOrgId,
    setSelectedOrgId,
    identifierId,
    setIdentifierId,
    jsonInput,
    jsonParseError,
    isFetching,
    isRunning,
    isJsonValid,
    evaluationResult,
    runError,
    expandedStageIds,
    handleJsonInputChange,
    handleFetch,
    handleRun,
    handleReset,
    handleRefresh,
    toggleStageExpanded,
  } = usePlayGround();

  return (
    <div className="play-ground-layout flex h-full flex-col overflow-hidden">
      <div className="play-ground-layout__content flex-1 overflow-y-auto py-4">
        <div className="play-ground-layout__org-selector mb-4 w-full max-w-sm">
          <SearchableSelect
            key={selectedOrgId}
            id="playground-org"
            options={PLAYGROUND_ORG_OPTIONS}
            label="Organization"
            placeholder="Select Organization"
            defaultValue={selectedOrgId}
            onOptionChange={(option: { value: string }) =>
              setSelectedOrgId(option.value)
            }
          />
        </div>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <InputPanel
            identifierId={identifierId}
            onIdentifierChange={setIdentifierId}
            jsonInput={jsonInput}
            jsonParseError={jsonParseError}
            isFetching={isFetching}
            isRunning={isRunning}
            isJsonValid={isJsonValid}
            onJsonInputChange={handleJsonInputChange}
            onFetch={handleFetch}
            onRun={handleRun}
            onReset={handleReset}
          />
          <ResultsPanel
            isRunning={isRunning}
            evaluationResult={evaluationResult}
            runError={runError}
            expandedStageIds={expandedStageIds}
            onToggleExpand={toggleStageExpanded}
            onRefresh={handleRefresh}
          />
        </div>
      </div>
    </div>
  );
};

export default PlayGround;
